import * as React from 'react';
import { SVGProps } from 'react';

const IconGasSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.5 1a.5.5 0 1 0 0 1v1H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1h-.5V2a.5.5 0 1 0 0-1h-3Zm2 2V2h-1v1h1ZM6 8.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
    />
  </svg>
);
export default IconGasSizeXs;
